import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

/**
 * Share button — uses Web Share API on supported devices,
 * falls back to copy-to-clipboard. Use anywhere a URL needs sharing.
 */
export const ShareButton = ({ url, title = "Aurora Insights", text = "", testId = "btn-share", label = "Share" }) => {
  const onShare = async () => {
    const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
    if (!shareUrl) return;

    if (typeof navigator !== "undefined" && navigator.share) {
      try {
        await navigator.share({ title, text, url: shareUrl });
        return;
      } catch (e) {
        if (e && e.name === "AbortError") return; // user cancelled
        // fall through to clipboard
      }
    }
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Unable to share link");
    }
  };

  return (
    <button
      type="button"
      onClick={onShare}
      className="btn-ghost inline-flex items-center"
      data-testid={testId}
    >
      <Share2 size={14} className="mr-2" />
      {label}
    </button>
  );
};
